import { captureException } from '@sentry/react';

import { toast } from '@/shared/components/toasts/PlatformToast';
import { TbGift } from '@/vendor/react-icons-tb';

export const copyReferralLinkToClipboard = async (referralUrl: string): Promise<boolean> => {
    if (!referralUrl || !navigator.clipboard?.writeText) {
        toast.error('Unable to copy referral link', {
            description: 'Select the link and copy it manually.',
        });

        return false;
    }

    try {
        await navigator.clipboard.writeText(referralUrl);
        toast.success('Referral link copied', {
            description: 'Your personal invitation link is ready to share.',
            icon: <TbGift size='1rem' />,
        });

        return true;
    } catch (error) {
        captureException(error, { tags: { operation: 'referral.copy-link' } });
        toast.error('Unable to copy referral link', {
            description: 'Select the link and copy it manually.',
        });

        return false;
    }
};
